import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Library(): React.ReactElement {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#iconlibrary)">
        <path d="M17.7904 8.34933C17.5172 7.90796 17.0338 7.64456 16.4973 7.64456H15.1584V5.18843C15.1584 4.59558 14.6582 4.11342 14.0435 4.11342H7.48897C7.47935 4.11342 7.4729 4.11067 7.47029 4.10902L6.29723 2.46835C6.08917 2.17749 5.74612 2.00391 5.37946 2.00391H1.11484C0.500015 2.00391 0 2.48621 0 3.07892V14.8615C0 15.4682 0.512238 15.9619 1.14203 15.9619H14.4087C14.6154 15.9619 14.7939 15.8426 14.8803 15.6694L14.8807 15.6695L17.8536 9.69859C18.0692 9.26587 18.0455 8.76146 17.7904 8.34933ZM1.11484 3.05859H5.37946C5.41104 3.05859 5.43246 3.07246 5.43919 3.08194L6.61404 4.72495C6.81235 5.00235 7.13947 5.16811 7.48897 5.16811H14.0435C14.0804 5.16811 14.099 5.18541 14.1037 5.19159V7.64456H4.55974C3.96785 7.64456 3.42952 7.97813 3.18823 8.49449L1.05469 13.0603V3.08208C1.05936 3.0759 1.07803 3.05859 1.11484 3.05859ZM16.9095 9.22852L14.0821 14.9071H1.35585L4.14377 8.94109C4.21133 8.79648 4.3786 8.69925 4.55974 8.69925H16.4973C16.6658 8.69925 16.814 8.77602 16.8937 8.90456C16.9384 8.97693 16.9774 9.09187 16.9095 9.22852Z" />
      </g>
      <defs>
        <clipPath id="iconlibrary">
          <rect width="18" height="18" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
